import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoginPage from './auth/LoginPage';
import TwoFactorPage from './auth/TwoFactorPage';
import RegisterPage from './auth/RegisterPage';
import PortalInvitePage from './auth/PortalInvitePage';
import ProtectedRoute from './auth/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import DashboardSettings from './pages/DashboardSettings';
import ClientDashboard from './pages/ClientDashboard';
import ClientChartTabs from './pages/ClientChartTabs';
import AddClient from './pages/AddClient';
import MidwifeClientList from './pages/MidwifeClientList';
import AppointmentsPage from './pages/AppointmentsPage';
import MessagesPage from './pages/MessagesPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/2fa" element={<TwoFactorPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/portal-invite" element={<PortalInvitePage />} />
      
      {/* Protected Routes */}
      <Route path="/midwife" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/midwife/settings" element={<ProtectedRoute><DashboardSettings /></ProtectedRoute>} />
      <Route path="/midwife/clients" element={<ProtectedRoute><MidwifeClientList /></ProtectedRoute>} />
      <Route path="/midwife/clients/new" element={<ProtectedRoute><AddClient /></ProtectedRoute>} />
      <Route path="/midwife/appointments" element={<ProtectedRoute><AppointmentsPage /></ProtectedRoute>} />
      <Route path="/midwife/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
      <Route path="/charting/:clientId" element={<ProtectedRoute><ClientChartTabs /></ProtectedRoute>} />
      
      {/* Client Routes */}
      <Route path="/client" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
      <Route path="/client/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
      <Route path="/client/appointments" element={<ProtectedRoute><AppointmentsPage /></ProtectedRoute>} />
      <Route path="/client/documents" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
      <Route path="/client/midwife" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
      <Route path="/client/settings" element={<ProtectedRoute><DashboardSettings /></ProtectedRoute>} />
      
      {/* Default redirect */}
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
} 